import { Chip, ChipProps } from "@mui/material";
import { CloseIcon } from "src/icons/CloseIcon";
import { UserLabels } from "src/model/api/v2/data-contracts";
import { getContrastColor } from "src/utils/labelColors";

interface LabelChipProps extends Omit<ChipProps, 'label'> {
    labelData: UserLabels;
}

export const LabelChip = ({ labelData, ...rest }: LabelChipProps) => (
    <Chip
        label={labelData.name}
        sx={{
            backgroundColor: labelData.color,
            color: getContrastColor(labelData.color),
            borderRadius: '16px !important',
        }}
        deleteIcon={
            <CloseIcon
                sx={{
                    color: `${getContrastColor(labelData.color)} !important`,
                    backgroundColor: '#ffffff99',
                    borderRadius: '50% !important',
                    padding: '3px !important',
                    fontWeight: 'bold !important',
                    fontSize: '14px !important',
                    margin: '0 8px 0 0 !important',
                }}
            />
        }
        {...rest}
    />
);
